import angular from 'angular';
import usageDataComponent from './bulk-usage-data.component';

export default angular.module('components.dashboard.bulk-usage-data', [])
  .component('bulkUsageData', usageDataComponent)
  .value('EventEmitter', payload => ({ $event: payload }))
  .name;



// WEBPACK FOOTER //
// ./components/app/common/bulk-usage-data/bulk-usage-data.module.js